import React, { Suspense, lazy } from "react"
import ReactDOM from "react-dom"
import { Provider } from "react-redux"
import { Layout } from "./utility/context/Layout"
import * as serviceWorker from "./serviceWorker"
import { store, persistor } from "./redux/storeConfig/store"
import { PersistGate } from 'redux-persist/integration/react';
import Spinner from "./components/@vuexy/spinner/Fallback-spinner"
import "./index.scss"
import "./@fake-db"
import { UserProvider } from './context/context'
import 'react-toastify/dist/ReactToastify.css'
import { ContextUsuariosProvider } from "./context/contextUsuarios"
import { ContextOperacionPlantaFaseProvider } from "./context/contextOperacionPlantaFase"
import { ContextPlantaFaseProvider } from "./context/contextPlantaFase"
import ContextOperacionProvider from "./context/contextOperacion"
import ContextExtratificadaProvider from "./context/ContextExtratificadas"
import * as Sentry from "@sentry/react";

const LazyApp = lazy(() => import("./App"))

window.addEventListener('error', (event) => {
  if (event.message && event.message.includes('Loading chunk')) {
    console.error('Error al cargar un chunk:', event.message);
    window.location.href = '/';
  }
});

window.addEventListener('unhandledrejection', (event) => {
  if (event.reason && event.reason.message && event.reason.message.includes('Loading chunk')) {
    console.error('Error de promesa no manejada al cargar un chunk:', event.reason.message);
    window.location.href = '/'; 
  }
});

Sentry.init({
  dsn: "https://5f1fc4907715afc33e54076c8b077461@o4508365036060672.ingest.us.sentry.io/4508365038092288",
  integrations: [],
  
});



// configureDatabase()
ReactDOM.render(
  <Provider store={store}>
    <ContextExtratificadaProvider>
      <ContextUsuariosProvider>
        <ContextOperacionPlantaFaseProvider>
          <ContextPlantaFaseProvider>
            <ContextOperacionProvider>
              <UserProvider>

                <PersistGate loading={null} persistor={persistor}>
                  <Suspense fallback={<Spinner />}>
                    <Layout>
                      <LazyApp />

                    </Layout>
                  </Suspense>
                </PersistGate>

              </UserProvider>
            </ContextOperacionProvider>
          </ContextPlantaFaseProvider>
        </ContextOperacionPlantaFaseProvider>
      </ContextUsuariosProvider>
    </ContextExtratificadaProvider>
  </Provider>,
  document.getElementById("root")
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
